import { combineReducers } from 'redux';

import {
  setArticleForm,
  setArticleFormsSubmit,
  setArticleFormsReset,
  removeArticleForm,
  saveArticleDocumentSuccess,
  saveArticleDocumentFail,
  saveArticleVideoFail,
  saveArticleVideoSuccess,
} from '../actions';
import { ArticleAction, StateForms } from '../types';
import { Reducer } from '../../../types';

type ReducerOf<T extends keyof StateForms> = Reducer<StateForms, ArticleAction, T>;

const forms: ReducerOf<'forms'> = (state = null, action) => {
  switch (action.type) {
    case setArticleForm.type:
      if (state) {
        return [...state.filter((item) => item.id !== action.payload.id), action.payload];
      }
      return [action.payload];

    case removeArticleForm.type:
      if (state) {
        return state.filter((item) => item.id !== action.payload);
      }
      return state;

    default:
      return state;
  }
};

const isSubmit: ReducerOf<'isSubmit'> = (state = false, action) => {
  switch (action.type) {
    case setArticleFormsSubmit.type:
      return action.payload;

    case saveArticleDocumentSuccess.type:
    case saveArticleDocumentFail.type:
    case saveArticleVideoSuccess.type:
    case saveArticleVideoFail.type:
      return false;
    default:
      return state;
  }
};

const isReset: ReducerOf<'isReset'> = (state = false, action) => {
  switch (action.type) {
    case setArticleFormsReset.type:
      return action.payload;

    default:
      return state;
  }
};

export default combineReducers<StateForms>({
  forms,
  isSubmit,
  isReset,
});
